import { ROUTE_PATH, genderList } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaSelectModel, SmBtnMetaModel, SmMetaTextAreaModel } from "common/models/utility-models/meta-model";

export class ChangeMentorMetaModel extends FormMetaModel {
    constructor() {
        super('Add Mentor', ROUTE_PATH.mentorMappingList, '', 3);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const mentorId = new SmMetaSelectModel(
            'mentorId',
            'mentorId',
            'select',
            false,
            'col-12 col-md-4 col-lg-4',
            1,
            1,
            'Select Mentor',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'mentorName',
            'id',

        );

        const mentor_email = new SmMetaInputModel(
            'mentor_email',
            'mentor_email',
            'input',
            false,
            'input-fg form-group col-4 col-md-4',
            1,
            2,
            'Mentor Email',
            'text',
            '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}',
            true,
            true,
            true,
            false,
            100,
            5,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Mentor Email"
        );
        const mentor_mobile = new SmMetaInputModel(
            'mentor_mobile',
            'mentor_mobile',
            'input',
            false,
            'col-4 col-md-4',
            1,
            3,
            'Mentor Mobile Number',
            'number',
            '',
            true,
            true,
            true,
            false,
            10,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Mentor Mobile Number"
        
        );

        const remarks = new SmMetaTextAreaModel(
            'remarks',
            'remarks',
            'SimpleTextarea',
            false,
            'col-12 ',
            2,
            4,
            'Mentor Remarks',
            'textarea',
            '',
            false,
            true,
            false,                        //This was true but for removing validation on remarks this was made false
            false,
            100,
            1,
            false,
            false
        );
       
        // new SmMetaInputModel(
        //     'mentorContact',
        //     'mentorContact',
        //     'input',
        //     true,
        //     'col-6 col-md-6 col-lg-6',
        //     2,
        //     3,
        //     'Mentor Contact',
        //     'text',
        //     '',
        //     false,
        //     true,
        //     true,
        //     false,
        //     12,
        //     10
        // );
        const buttons = {
            submit: new SmBtnMetaModel('SUBMIT', '', true, false, true, true),
            isFormControl: false
        };
        return {
            formInfo,
            buttons,
            mentorId,
            mentor_email,
            mentor_mobile,
            remarks
        }
    }


}